export default __webpack_public_path__ + "static/media/cancel.140bb64c.svg";